/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Impero Org API
 * The Impero Backend's API for organizations, i.e. orgname.impero.com.
 */

export type StandardAccessRight =
    (typeof StandardAccessRight)[keyof typeof StandardAccessRight];

export const StandardAccessRight = {
    Admin: "Admin",
    Edit: "Edit",
    View: "View",
} as const;
